export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 px-4 md:px-8 bg-background-950">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-8 flex items-center justify-center rounded-2xl bg-accent-500/10">
          <i className="ri-eye-2-line text-2xl text-accent-400"></i>
        </div>

        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-background-800/80 text-background-400 text-xs font-semibold rounded-full border border-background-700/60 whitespace-nowrap mb-6">
          <i className="ri-information-line text-[10px]"></i>
          关于我们
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-background-950 mb-6 leading-tight tracking-tight">
          全网最全 <span className="font-heading italic text-accent-600">吃瓜平台</span>
        </h2>

        <p className="text-base md:text-lg text-background-600 leading-relaxed max-w-2xl mx-auto">
          51爆料网成立于2024年，致力于打造中文互联网最具影响力的娱乐资讯聚合平台。我们拥有一支专业的资讯采集团队，7×24小时不间断追踪明星动态、网红内幕与社会热点。所有内容均来自公开渠道整理与用户投稿，严格遵循信息真实性原则，为每一位吃瓜群众提供最及时、最全面、最劲爆的爆料资讯。在这里，真相从不缺席，瓜从不间断。
        </p>

        <div className="flex flex-wrap items-center justify-center gap-8 mt-10 text-sm">
          <div className="text-center">
            <div className="text-3xl font-extrabold text-accent-500">50万+</div>
            <div className="text-xs text-background-500 mt-1">日均活跃用户</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-extrabold text-accent-500">12万+</div>
            <div className="text-xs text-background-500 mt-1">累计爆料内容</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-extrabold text-accent-500">99.7%</div>
            <div className="text-xs text-background-500 mt-1">用户满意度</div>
          </div>
        </div>
      </div>
    </section>
  );
}